import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setLanguage } from './helpers/i18n'

// prevent clickjacking
if (window.top != window.self) {
  window.top.location = window.self.location
}

let qs = new URLSearchParams(window.location.search)

// was some language supplied?
if (qs.get('lang')) {
  setLanguage(qs.get('lang'))
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
